import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert } from 'reactstrap'
import { CONFIGURATION_QUERY } from '../../graphql.js'
import { handleGraphQLErrors } from '../../utils.js'
import { CONFIG_KEYS } from '../../constants'

const CONFIGURATION = gql(CONFIGURATION_QUERY)

export default function SignUpLink() {
  console.log('SignUpLink rendered')

  const [value, setValue] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function getConfigValue() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: CONFIGURATION, variables: { key: CONFIG_KEYS.showSignUpLink.key } })
        console.log('SignUpLink: ', { data, errors })
        if (data && data.configuration && data.configuration.value) {
          setValue(data.configuration.value)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    getConfigValue()
  }, [])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (value === 'Y') {
    return (
      <div style={{ paddingTop: '10px'}}>Don't have an account? Sign up <a href="signUp">here</a></div>
    )
  }
  return ''
}
